import {store} from "@irati/store"
import {isFunction} from "lodash"

import AuthActions from "@irati/auth/store/actions/AuthActions"
import userService from "@irati/identity/services/users"
import {uploadImage, deleteImage} from "../services/image"

export default (user, img) => {
  const oldImage = user.profile_img

  // @TODO: This have been changed from
  // `return Promise.resolve(user)` to `return updateUser(user)`
  // in order to have this working with native. With this, it's possible
  // to update the user details using this function avoiding code duplication
  // This should be reverted when we have new design for Edit Profile Picture screen
  if (!hasProfileImageChanged(img)) return updateUser(user, oldImage)

  return uploadImgOrResolve(img).then((imageLink) => {
    return updateUser(user, imageLink).then((updatedUser) => {
      return deleteImgOrResolve(oldImage).then(() => updatedUser)
    })
  })
}

export function hasProfileImageChanged(img) {
  if (img && isFunction(img.includes)) {
    return !img.includes("https://")
  }
  return true
}

function deleteImgOrResolve(img) {
  if (!img) return Promise.resolve()

  return deleteImage({url: img})
}

function uploadImgOrResolve(img) {
  if (!img) return Promise.resolve(null)

  return uploadImage(img)
}

function updateUser(user, imageLink) {
  const data = {
    uuid: user.uuid,
    profileImageUrl: imageLink
  }
  return userService.update({user: data}).then((updatedUser) => {
    return store.dispatch(AuthActions.UpdateAuthAction({user: updatedUser}))
  })
}
